
import React from 'react';
import classNames from 'classnames';
import SvgIcon, { iconDefaultProps, iconPropTypes } from '../components/SvgIcon';
import { ErgoElementsContext } from '../components/Provider';

/**
 * Factory function to create themed SVG icon components.
 *
 * @param {Object} opts - Icon configuration.
 * @param {string} opts.componentName - Display name for the icon component.
 * @param {string} opts.viewBox - SVG viewBox attribute.
 * @param {string} opts.g - Default SVG path or group markup.
 * @param {Object} [opts.gThemed] - Optional themed variants keyed by theme name.
 * @returns {React.FC} Icon component.
 */
export function iconFactory(opts) {
  const Icon = (props) => {
    const { className, spinning, ...other } = props;

    const componentClassName = classNames(
      'ee_icon',
      { 'ee_icon--spinning': spinning },
      className
    );

    return (
      <ErgoElementsContext.Consumer>
        {(context) => {
          const { theme, idGenerator } = context;

          // Determine themed icon variant
          let themedOpts = opts.gThemed && opts.gThemed[theme];
          if (!themedOpts && (theme === 'das' || theme === 'dkv')) {
            themedOpts = opts.gThemed && opts.gThemed.ergo;
          }

          const { g, viewBox } = themedOpts || opts;

          return (
            <SvgIcon
              {...other}
              idGenerator={idGenerator}
              className={componentClassName}
              viewBox={viewBox}
              g={g}
            />
          );
        }}
      </ErgoElementsContext.Consumer>
    );
  };

  Icon.defaultProps = iconDefaultProps;
  Icon.propTypes = iconPropTypes;
  Icon.displayName = opts.componentName;

  return Icon;
}
